module.exports = __webpack_public_path__ + "img/slide3.3dc13c68.png";